import { gql } from '@apollo/client';

export const MY_WALLET_MONTHLY_EARNINGS = gql`
  query MyWalletMonthlyEarnings($months: Int) {
    myWalletMonthlyEarnings(months: $months) {
      currency
      months {
        month
        clips_cents
        affiliate_cents
        producer_cents
        total_cents
      }
    }
  }
`;
